import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';


export default function Main() {
  const [pass,setPassword]=useState('')
  const [username,setUsername]=useState('')

  useEffect(() => {
    const access=JSON.parse(localStorage.getItem("admin"))
    if(access!=null)
    {
      window.location.replace("/main");
    }
  }, []);



  const login = async ()=> {
    const data = new FormData();
    data.append('email',username);
    data.append('pass',pass);

            axios({
              method: 'post',
              url: '/api/user/login.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
               
                console.log("login")

                if(s.data[0].msg=="disable")
                {
                  alert("Your Account is Disable")
                  
                }else if(s.data[0].msg=="fail")
                  {
                    alert("Failed, try Again !!!!")
                  }else{
                   
                    localStorage.setItem('admin', JSON.stringify(s.data));
                    
                    window.location.replace("/main");

                  }
               
         
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  return (
    <>
<section className="min-vh-100 d-flex align-items-center bg-light py-5">
  <div className="container">
    <div className="row justify-content-center">
      
      <div className="col-lg-5 col-md-7">
        <div
          className="card border-0 shadow-lg rounded-4 overflow-hidden"
        >
          
          {/* Top Banner */}
          <div
            className="text-center text-white py-4"
            style={{
              background: "linear-gradient(135deg, #0d6efd, #4f8cff)",
            }} >
            <h2 className="fw-bold mb-1">Admin Express Umrah</h2>
            <p className="mb-0 opacity-75">Welcome Back 👋</p>
          </div>

          {/* Form */}
          <div className="card-body p-4 p-lg-5">
            
            <div className="form-group mb-4">
              <label className="form-label fw-semibold">
                Username
              </label>
              <input
                type="text"
                name="user_name"
                className="form-control form-control-lg rounded-3"
                placeholder="Enter username"
                value={username}
                onChange={(v) => {
                  setUsername(v.target.value);
                }}
              />
            </div>

            <div className="form-group mb-4">
              <label className="form-label fw-semibold">
                Password
              </label>
              <input
                type="password"
                name="password_name"
                className="form-control form-control-lg rounded-3"
                placeholder="Enter password"
                value={pass}
                onChange={(v) => {
                  setPassword(v.target.value);
                }}
              />
            </div>

            <button
              className="btn btn-primary w-100 py-3 rounded-3 fw-semibold"
              onClick={() => {
                if (username.length < 4 || pass.length < 4) {
                  alert("Enter Correct Username and password !");
                } else {
                  login();
                }
              }}
            >
              Login
            </button>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


  </>

  )
}
